import axios from "axios";
import router from "../router";
import i18n from "../lang";
import AuthUtils from "@/utils/auth";
import store from "@/store";
// 创建axios实例
const request = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, // api的base_url
	timeout: 50000, // 请求超时时间
});

// 请求拦截器
request.interceptors.request.use(
	(config) => {
		let token = sessionStorage.getItem("token");
		let lang = store.state.isLand === "en" ? "en" : "zh-cn";
		// ThinkPHP reads the lang query parameter, not the custom lang header.
		config.params = { ...config.params, lang };
		config.headers["token"] = token;
		config.headers["lang"] = lang;
		config.headers["X-Requested-With"] = "XMLHttpRequest";
		if (!config.headers["Content-Type"]) {
			config.headers["Content-Type"] = "application/json";
		}
		let obj = config.data || {};
		config.data = obj;
		return config;
	},
	(error) => {
		// 请求错误处理
		Promise.reject(error);
	}
);

// 响应拦截器
request.interceptors.response.use(
	(response) => {
		// 处理错误码
		const handlerResult = errorCodeHandler(response.data.code);
		if (handlerResult !== undefined) {
			return handlerResult;
		}

		// 对响应数据做处理，例如只返回data部分
		const res = response.data;
		let i18nMessage = i18n.locale;
		// 根据返回的状态码做相应处理，例如401未授权等
		return res;
	},
	(error) => {
		// 响应错误处理
		if (error.code === "ERR_NETWORK") {
			console.error("网络连接失败，请检查：");
			console.error(`1. 服务 ${error.config.baseURL} 是否运行`);
			console.error("2. 网络是否通畅");
			console.error("3. 是否配置了正确的CORS");
			return { code: 0, msg: "网络连接失败", data: null };
		} else if (error.response?.status == 401) {
			store.commit('SET_ClEAR')
			return error.response.data
		}
		const handlerResult = errorCodeHandler(error.response?.status);
		if (handlerResult !== undefined) {
			return handlerResult;
		}

		return Promise.reject(error);
	}
);

function errorCodeHandler(code) {
	switch (code) {
		case 401:
			// AuthUtils.logout();
			return;
		// return Promise.reject(new Error("token过期"));
		case 403:
			return;
		case 404:
			return;
		case 405:
			return;
		case 406:
			return;
		case 407:
			return;
		case 500:
			return { code: 500, msg: "Server Error", data: null };
		default:
			return;
	}
}

export default request;
